// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/aff06bbbf9bd38e99770.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"6e1246a6c982cded2056","121":"204a6ac73a14f650b50d","122":"02ba4fec6c1d294919f7"}[chunkId] + ".chunk.js";
};